<template>
    <v-container class="pa-0 my-8">
        <h3>{{ campo.rotulo }}</h3>
        <p v-if="campo.ajuda">{{ campo.ajuda }}</p>
        <v-checkbox
            v-for="opcao in campo.opcoes"
            :key="opcao.nome"
            v-model="valoresInternos[opcao.nome]"
            :label="opcao.texto"
            @change="update"
            class="pa-0 ma-0"
        />
        <v-divider></v-divider>
    </v-container>
</template>

<script>
export default {
    name: "caixa-de-checagem",
    props: {
        value: {
            reqiured: false,
        },
        campo: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            valoresInternos: {},
        };
    },
    mounted() {
        this.inicializarValores();
    },
    methods: {
        inicializarValores() {
            if (!this.value) {
                this.valoresInternos = this.campo.opcoes.reduce(
                    (acc, opcao) => {
                        acc[opcao.nome] = opcao.valor;
                        return acc;
                    },
                    {},
                );
                console.log(this.valoresInternos);
                this.$emit("input", this.valoresInternos);
            } else {
                this.valoresInternos = { ...this.value };
            }
        },
        update() {
            this.$emit("input", this.valoresInternos);
        },
    },
};
</script>

<style></style>
